/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React from 'react';

const ThemeSwitcher = ({ themes, setCurrentTheme }) => (
  <div
    className="fixed left-4 top-1/2 -translate-y-1/2 z-[100] bg-white p-2 rounded-full shadow-lg border flex flex-col gap-2 hidden"
    aria-hidden="true"
    style={{ display: 'none' }} // مخفي بصرياً لكن يبقى الكود لدعم التحديد من الـ API لاحقاً
  >
    {Object.keys(themes).map((t) => (
      <button
        key={t}
        onClick={() => setCurrentTheme(t)}
        className="w-5 h-5 rounded-full border border-gray-200"
        style={{ backgroundColor: themes[t].primary }}
      />
    ))}
  </div>
);

export default ThemeSwitcher;
